module.exports = __webpack_public_path__ + "img/image_part_005.736e0a1d.jpg";